export const BASE_URL = 'https://jfcodes.cn'



// WEBPACK FOOTER //
// ./src/config/index.js